// src/components/ReportsDashboard.jsx
import React from "react";
import ReactECharts from "echarts-for-react";

export default function ReportsDashboard({ overview, tracking }) {
  if (!overview) return <p>No data available</p>;

  const overviewChart = {
    title: { text: "Project Status Overview", left: "center" },
    tooltip: { trigger: "item" },
    series: [
      {
        name: "Status",
        type: "pie",
        radius: "50%",
        data: [
          { value: overview.completed, name: "Completed" },
          { value: overview.pending, name: "Pending" },
          { value: overview.delayed, name: "Delayed" },
        ],
      },
    ],
  };

  const trackingChart = {
    title: { text: "Tasks Over Time", left: "center" },
    tooltip: { trigger: "axis" },
    xAxis: { type: "category", data: tracking.map((t) => t.date) },
    yAxis: { type: "value" },
    series: [
      {
        name: "Tasks Completed",
        type: "line",
        data: tracking.map((t) => t.tasks),
      },
    ],
  };

  return (
    <div className="space-y-8">
      {/* Overview Cards */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-sm font-semibold text-gray-500">Submitted</h3>
          <p className="text-2xl font-bold">{overview.submitted}</p>
        </div>
        <div className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-sm font-semibold text-gray-500">Pending</h3>
          <p className="text-2xl font-bold">{overview.pending}</p>
        </div>
        <div className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-sm font-semibold text-gray-500">Evaluated</h3>
          <p className="text-2xl font-bold">{overview.evaluated}</p>
        </div>
        <div className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-sm font-semibold text-gray-500">Not Evaluated</h3>
          <p className="text-2xl font-bold">{overview.notEvaluated}</p>
        </div>
      </div>

      {/* Graphs */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white p-4 shadow rounded">
          <ReactECharts option={overviewChart} style={{ height: "300px" }} />
        </div>
        <div className="bg-white p-4 shadow rounded">
          <ReactECharts option={trackingChart} style={{ height: "300px" }} />
        </div>
      </div>

      {/* Tracking Table */}
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 border-b">
          <h3 className="text-lg font-semibold">Tracking</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-2 text-left">Title</th>
                <th className="px-4 py-2 text-left">Assigned Role</th>
                <th className="px-4 py-2 text-left">Status</th>
                <th className="px-4 py-2 text-left">Submitted At</th>
                <th className="px-4 py-2 text-left">Submitted By</th>
              </tr>
            </thead>
            <tbody>
              {tracking.map((report, index) => (
                <tr key={index} className="border-t">
                  <td className="px-4 py-2">{report.title || "-"}</td>
                  <td className="px-4 py-2">{report.assignedRole || "-"}</td>
                  <td className="px-4 py-2">{report.status || "-"}</td>
                  <td className="px-4 py-2">
                    {report.submittedAt
                      ? new Date(report.submittedAt).toLocaleDateString()
                      : "-"}
                  </td>
                  <td className="px-4 py-2">{report.submittedBy || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
